import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { LoggerService } from '../logger/logger.service';
import { Router } from '@angular/router';
import { NotificationService } from '../services/notification.service';

@Injectable({
    providedIn: 'root'
})
export class DefaultErrorHandler implements ErrorHandler {

    constructor(private injector: Injector) { }

    handleError(error: Error): void {
        const logger = this.injector.get(LoggerService);
        const notificationService = this.injector.get(NotificationService);
        // const router = this.injector.get(Router);
        if (error instanceof HttpErrorResponse) {
          let msg = error.message;
          if (!navigator.onLine) {
            msg = 'No internet connection';
          }

          logger.error(msg, error);
          notificationService.notify(msg);
        } else {
          logger.error(error.message, error);
          // router.navigate(['/error'], { queryParams: {error: error} });
        }
    }
}
